// extracted by mini-css-extract-plugin
export default {"textarea":"TextArea_textarea__6lOOJ","default":"TextArea_default__yDGtX","note":"TextArea_note__kuHvo","note-video":"TextArea_note-video__cVBgJ"};